import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Card from "react-bootstrap/Card";
import EntityHeader from "./common/EntityHeader";
import FieldDisplay from "./common/FieldDisplay";
import { getFieldText, getFieldName } from "../scripts/helperScripts";
import "react-datepicker/dist/react-datepicker.css";

function DemographicsEntity({ contact, businessUnitName, ...rest }) {
  const navigate = useNavigate();
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));

  //Route Access Protection
  useEffect(() => {
    if (safyInfo) {
      const modules = safyInfo.user.modules;
      if (
        modules.includes("My Caseload") === false &&
        modules.includes("Team Caseload") === false
      ) {
        navigate("/");
      }
    } else navigate("/");
  });

  const getRace = () => {
    const races = [];

    if (getFieldName(contact.sor_consideryourselfhispaniclatino) === "Yes")
      races.push("Hispanic/Latino");

    if (getFieldName(contact.sor_americanindianoralaskannative) === "Yes")
      races.push("American Indian or Alaskan Native");

    if (
      getFieldName(contact.sor_nativehawaiianorotherpacificislander) === "Yes"
    )
      races.push("Native Hawaiian or Pacific Islander");

    if (getFieldName(contact.sor_blackorafricanamerican) === "Yes")
      races.push("Black or African American");

    if (getFieldName(contact.sor_white) === "Yes") races.push("White");

    if (getFieldName(contact.sor_asian) === "Yes") races.push("Asian");

    return races.join(", ");
  };

  return (
    <>
      <EntityHeader
        title={"Demographics"}
        add={() => {
          navigate(`/contact/${contact.contactid}`, {
            state: { businessUnitName: businessUnitName },
          });
        }}
        {...rest}
        body={
          contact.ccx_alias1 !== undefined ||
          contact.ccx_alias2 !== undefined ||
          contact.sor_preferredgender !== undefined ||
          contact.sor_primarylanguage !== undefined ||
          contact.sor_sexualorientation !== undefined ||
          contact.sor_pronouns !== undefined ||
          contact.sor_white !== undefined ||
          contact.sor_blackorafricanamerican !== undefined ||
          contact.sor_asian !== undefined ||
          contact.sor_americanindianoralaskannative !== undefined ||
          contact.sor_nativehawaiianorotherpacificislander !== undefined ||
          contact.sor_consideryourselfhispaniclatino !== undefined ? (
            <div className="d-block p-2">
              <Card bg="dark" className="card-safy">
                <Card.Body className="p-2 card-body-safy">
                  {contact.ccx_alias1 !== undefined ||
                  contact.ccx_alias2 !== undefined ? (
                    <FieldDisplay
                      label="Preferred Name: "
                      value={`${contact.ccx_alias2}, ${contact.ccx_alias1}`}
                    />
                  ) : null}
                  {contact.sor_preferredgender !== undefined ? (
                    <FieldDisplay
                      label="Gender: "
                      value={getFieldName(contact.sor_preferredgender)}
                    />
                  ) : null}
                  {contact.sor_primarylanguage !== undefined ? (
                    <FieldDisplay
                      label="Primary Language: "
                      value={getFieldName(contact.sor_primarylanguage)}
                    />
                  ) : null}
                  {contact.sor_sexualorientation !== undefined ? (
                    <FieldDisplay
                      label="Sexual Orientation: "
                      value={getFieldName(contact.sor_sexualorientation)}
                    />
                  ) : null}
                  {contact.sor_americanindianoralaskannative !== undefined ||
                  contact.sor_asian !== undefined ||
                  contact.sor_blackorafricanamerican !== undefined ||
                  contact.sor_consideryourselfhispaniclatino !== undefined ||
                  contact.sor_nativehawaiianorotherpacificislander !==
                    undefined ||
                  contact.sor_white !== undefined ? (
                    <FieldDisplay label="Race: " value={getRace()} />
                  ) : null}
                  {contact.sor_pronouns !== undefined ? (
                    <FieldDisplay
                      label="Pronouns: "
                      value={
                        getFieldText(contact.sor_pronouns) === "186460003"
                          ? contact.sor_pronounsother
                          : getFieldName(contact.sor_pronouns)
                      }
                    />
                  ) : null}
                </Card.Body>
              </Card>
              {contact.sfy_referringagencyname !== undefined ? (
                <Card bg="dark" className="card-safy mt-3">
                  <Card.Body className="p-2 card-body-safy">
                    <FieldDisplay
                      label="Referring Agency: "
                      value={getFieldName(contact.sfy_referringagencyname)}
                    />
                  </Card.Body>
                </Card>
              ) : null}
            </div>
          ) : null
        }
      />
    </>
  );
}

export default DemographicsEntity;
